import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import styleguide from 'aria-viewer/tour/constants/styleGuide'

const styleSheet = {
    container: {
        height: ({ options: { individualHeight } }) => individualHeight,
        top: ({ options: { index, step, ii } }) => index * step + (ii - index) * 30,
        position: 'absolute',
        fontSize: '0.8em',
        left: -2,
        whiteSpace: 'nowrap',
        transitionProperty: 'all',
        transitionDuration: styleguide.delay.fast,
        opacity: ({ options: { ii, index } }) => (ii - index == 0 ? 1 : ii - index == 1 ? 0.5 : 0),
        transform: ({ options: { ii, index } }) =>
            ii - index == 0 ? 'scale(1)' : ii - index == 1 ? 'scale(.9)' : 'scale(.6)',
    },

    title: {
        left: 12,
        top: '50%',
        position: 'absolute',
        transform: 'translateY(-50%)',
        maxWidth: '10em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        letterSpacing: 0,
        textShadow: '0 1px 1px rgba(0, 0, 0, 0.5)',
        fontSize: 18,
        fontWeight: 500,
    },
}

const style = injectSheet(styleSheet)

const StopsListTitle = ({ classes, options: { ii, title } }) => (
    <div key={ii} className={classes.container}>
        <div className={classes.title} alt={title}>
            {title}
        </div>
    </div>
)

export default compose(
    style,
    pure
)(StopsListTitle)
